<template>
    <div class="app-container">
        <div class="tiHuoDanGuanLiWarp-body">
            <div class="top">
                <div ref="searchBox" class="formBox margbot">
                    <!-- 标题 -->
                    <!-- <div class="detailsTitle">
                        <h4>排队叫号</h4>
                    </div> -->
                    <!--按钮-->
                    <div style="padding-bottom:10px">队列列表：
                        <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
                        <el-button type="primary" size="mini" @click="jiaohao" btnCode="01K00B0100"
                            v-if="btnFlg[0]">叫号</el-button>
                        <el-button type="primary" size="mini" @click="tingzhiJH" btnCode="01K00B0200"
                            v-if="btnFlg[1]">停止叫号</el-button>
                    </div>
                </div>
                <!--表格-->
                <div class="tiHuoDanGuanLiWarp-body-table" :style="{ height: h }">
                    <el-table height="100%" size="mini" ref="multipleTable" :data="tableData" style="width:100%"
                     :row-style="{ height: '20px' }" :cell-style="{ padding: '0px' }" highlight-current-row class="tableComent" @row-click="dianjixuanzhong" :header-cell-style="{ background: '#F5F5F5', color: 'black' }">
                        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="queueName" label="队列名称"
                            align="center"></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="jobType" label="作业类型"
                            align="center"></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="product_type_name" label="货物类型"
                            align="center"></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="jobLocationCapacity" label="仓内作业位容量"
                            align="center" width="150"></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="availableLocationCapacity" label="仓内剩余作业位"
                            align="center"></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="esperarNumber" label="等待车数"
                            align="center"></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="callStationStatus" label="叫号状态" align="center">
                            <template slot-scope="scope">
                                <div>
                                    <span v-if="scope.row.callStationStatus == '2'" style="color:red">
                                        停止
                                    </span>
                                    <span v-else-if="scope.row.callStationStatus == '1'" style="color:blue">
                                        进行中
                                    </span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!--分页-->
                <!-- <div class="pags" style="text-align: left;">
                    <el-pagination background @current-change="handleCurrentChangeA" :current-page="current"
                        :page-size="pagesize" @size-change="handleSizeChangeA" :page-sizes="[10, 20, 30, 40, 50]"
                        layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
                </div> -->
            </div>
            <div class="bottom">
                <div ref="searchBox2" style="margin:5px 10px;">
                    排队详情：
                    <el-button type="primary" size="small" @click="chadui" btnCode="01K00B0300"
                        v-if="btnFlg[2]">插队</el-button>
                </div>
                <div class="tiHuoDanGuanLiWarp-body-table" :style="{ height: detailsH }">
                    <el-table height="100%" size="mini" ref="tabref" :data="detailsData" style="width:100%"
                        :header-cell-style="{ background: '#F5F5F5', color: 'black' }" @row-click="dianjixuanzhongCD"
                        highlight-current-row border center class="tableComent">
                        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
                        <!--<el-table-column type="selection" align="center" width="60" ></el-table-column>-->
                        <el-table-column :show-overflow-tooltip="true" prop="lineUpNo" label="排队序号" align="center"
                            width="150"></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="vehicleNo" label="车牌号" align="center"
                            width="120"></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="mobilePhone" label="手机号" align="center"
                            width="150"></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="jobStatusName" label="状态" align="center"
                            width="110">
                            <template slot-scope="scope">
                                <div>
                                    <!-- 1：排队中 2：已叫号 3：已过号 4：已失效 5：已进仓 6：进仓过磅完成 7：出仓过主磅完成 8：出仓过副磅完成 9：已出仓 -->
                                    <span v-if="scope.row.jobStatusName == '排队中'" style="color:blue">
                                        排队中
                                    </span>
                                    <span v-else-if="scope.row.jobStatusName == '已叫号'" style="color:red">
                                        已叫号
                                    </span>
                                    <span v-else-if="scope.row.jobStatusName == '已过号'" style="color:rgb(242, 159, 25)">
                                        已过号
                                    </span>
                                    <span v-else>
                                        {{ scope.row.jobStatusName }}
                                    </span>
                                </div>
                            </template>

                        </el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="registrationTime" label="登记时间" align="center"
                            width="180"></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="registrationTime" label="审核时间" align="center"
                            width="180"></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="callStationTime" label="叫号时间" align="center"
                            width="180"></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="mobilizationTime" label="进仓时间" align="center"
                            width="180"></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="overStationTime" label="过号时间" align="center"
                            width="180"></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="reReporTime" label="重新报到时间"
                            align="center"></el-table-column>
                    </el-table>
                </div>
                <!--分页-->
                <!-- <div class="pags" style="text-align: left;">
                    <el-pagination background @current-change="handleCurrentChangeB" :current-page="xqCurrent"
                        :page-size="xqPagsize" @size-change="handleSizeChangeB" :page-sizes="[10, 20, 30, 40, 50]"
                        layout="total, sizes, prev, pager, next, jumper" :total="xqTotal"></el-pagination>
                </div> -->

            </div>
            <el-dialog title="插队" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="addMarkBox"
                width="40%" center>
                <div style="width:80%; margin:15px auto;">

                    <div style="margin-bottom:20px">插入选中车辆前面，请选择要插队的车辆：</div>

                    <span>
                        <el-table :height="detailsH" size="mini" ref="tabref1" :data="tableDataCD" style="width:100%"
                            :row-style="{ height: '20px' }" @row-click="dianjixuanzhongCDOK"
                            :cell-style="{ padding: '0px' }" class="elTab" highlight-current-row
                            :header-cell-style="{ background: '#F5F5F5', color: 'black' }">
                            <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
                            <el-table-column :show-overflow-tooltip="true" prop="lineUpNo" label="排队序号"
                                align="center"></el-table-column>
                            <el-table-column :show-overflow-tooltip="true" prop="vehicleNo" label="车牌号"
                                align="center"></el-table-column>

                        </el-table>
                    </span>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="chaduiOK()">确 定</el-button>
                    <el-button @click="addMarkBox = false">取 消</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {

  getLlamadaQueueSettingsList, // 子数据
  operacionLlamar,
  operacionStopLlamar,
  getHacerColaList,
  getJumpQueueList,
  operacionJumpQueue

} from '@/api/lj'
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import { exportExcel } from '@/utils/fileDown.js'

export default {
  name: 'TiHuoDanZuoYe',
  data () {
    return {
      isDisable: false,

      // 按钮
      btnFlg: [],
      btnIdArr: ['01K00B0100', '01K00B0200', '01K00B0300'],
      h: '500px',
      detailsH: '200px',
      addMarkBox: false, // 来源为欧冶是时为true
      xuanzhongArr: [], // 当前选中行
      tableData: [], // 表格数据
      selctList: [], // 表格数据
      selctListCD: [], // 表格数据
      selctListCDOK: [], // 表格数据
      tableDataCD: [], // 表格数据
      CDList: [], // 表格数据
      detailsData: [], // 详情数据
      formInline: {
      },
      // 分页
      pagesize: 20,
      current: 1,
      total: 0,
      xqCurrent: 1,
      xqPagsize: 10,
      xqTotal: 0,
      allWeight: 0,
      detailsDataT: [], // 提货车辆
      activeName: 'first'

    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.6 * pH - h - 100 + 'px'
    this.detailsH = 0.4 * pH - 75 + 'px'
  },
  methods: {
    chaxun () {
      this.findBillMasterListS()
    },

    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.selctList = []
      this.selctList.push(row)
      this.findBillDetailListS(row)
    },
    dianjixuanzhongCD (row) {
      this.selctListCD = []
      this.selctListCD.push(row)
    },
    dianjixuanzhongCDOK (row) {
      this.selctListCDOK = []
      this.selctListCDOK.push(row)
    },
    // 插队
    chadui () {
      if (this.selctListCD.length == 0) {
        DonMessage.error('请选择要操作的数据')
      } else if (this.selctListCD[0].jobStatusName !== '排队中') {
        DonMessage.error('只能操作排队中的数据')
      } else {
        this.addMarkBox = true

        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        getJumpQueueList({ id: this.selctListCD[0].id })
          .then((res) => {
            loading.close()
            this.tableDataCD = res
          })
          .catch((err) => {
            loading.close()

            DonMessage.error(err.message)
          })
      }
    },
    chaduiOK () {
      if (this.selctListCDOK.length == 0) {
        DonMessage.error('请选择要操作的数据')
      } else {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        operacionJumpQueue({
          jumpQueueId: this.selctListCDOK[0].id,
          id: this.selctListCD[0].id
        })
          .then((res) => {
            this.addMarkBox = false

            loading.close()
            DonMessage.success('操作成功')
            // this.findBillMasterListS()
            this.findBillDetailListS(this.selctList[0])
          })
          .catch((err) => {
            loading.close()

            DonMessage.error(err.message)
          })
      }
    },
    // 查询按钮
    jiaohao () {
      if (this.selctList.length == 0) {
        DonMessage.error('请选择要操作的数据')
      } else {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        operacionLlamar({ id: this.selctList[0].id })
          .then((res) => {
            loading.close()
            DonMessage.success('操作成功')
            this.findBillMasterListS()
          })
          .catch((err) => {
            loading.close()

            DonMessage.error(err.message)
          })
      }
      // this.findBillMasterListS()
    },
    // 查询按钮
    tingzhiJH () {
      if (this.selctList.length == 0) {
        DonMessage.error('请选择要操作的数据')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      operacionStopLlamar({ id: this.selctList[0].id })
        .then((res) => {
          loading.close()
          DonMessage.success('操作成功')
          this.findBillMasterListS()
        })
        .catch((err) => {
          loading.close()

          DonMessage.error(err.message)
        })
    },

    // 时间格式化
    dateFormat: function (row, column) {
      var t = new Date(row.createTime) // row 表示一行数据, transferTime 表示要格式化的字段名称
      return t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate() // 年月日
    },

    // 主数据
    findBillMasterListS () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      getLlamadaQueueSettingsList({})
        .then((res) => {
          loading.close()
          this.tableData = res
          this.total = res.total
          if (this.tableData.length !== 0) {
            this.$nextTick(() => {
              this.selctList = []
              this.selctList.push(this.tableData[0])

              this.$refs.multipleTable.setCurrentRow(
                this.tableData[0],
                true
              )
            })
            this.findBillDetailListS(this.tableData[0])
          }
        })
        .catch((err) => {
          loading.close()

          DonMessage.error(err.message)
        })
    },

    // 子数据
    findBillDetailListS (row) {
      getHacerColaList({
        queueId: row.id
      })
        .then((res) => {
          this.xqTotal = res.total
          this.detailsData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.current = val
      this.findBillMasterListS()
    },
    handleSizeChangeA (val) {
      this.pagesize = val
      this.findBillMasterListS()
    },
    // 详情表格分页
    handleCurrentChangeB (val) {
      this.xqCurrent = val
      this.findBillDetailListS()
    },
    handleSizeChangeB (val) {
      this.xqPagsize = val
      this.findBillDetailListS()
    },
    // 重置按钮
    chongZhi () {
      this.findBillMasterListS()
    },

    // 表单
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/stationCalling')

    this.findBillMasterListS()
  }
}
</script>

<style lang="less" scoped>
//朱表格和详情表格样式
.inpBox {
    .el-form-item {
        margin-left: 10px;
        margin-bottom: 0px;
    }
}

.one {
    height: 700px;
    width: 100%;
    // border: 1px solid red;
    position: relative;
}

.two {
    height: 300px;
    width: 100%;
    border-top: 2px solid #005bba;
}

.tiHuoDanGuanLiWarp {
    width: 100%;
    position: relative;

    // border: solid 1px blue;
    .tiHuoDanGuanLiWarp-body {
        width: 100%;
        position: absolute;

        .tiHuoDanGuanLiWarp-body-queryIpt {
            margin-top: 5px;
            width: 90%;
            // border: solid 1px;
            display: flex;
            justify-content: space-between;

            div {
                font-size: 13px;

                .ipt {
                    width: 150px;
                }
            }
        }

        .tiHuoDanGuanLiWarp-body-btn {
            margin-top: 5px;
        }

        .tiHuoDanGuanLiWarp-body-table {
            margin-top: 5px;
        }

        // 添加弹框
        .addMarkBox {
            .addMarkBox-title {
                width: 100px;
                font-size: 18px;
                font-weight: 700;
                margin: 0 auto;
            }
        }
    }
}
</style>
